import HoveredResultCardAndPolyline from './HoveredResultCardAndPolyline';

export default HoveredResultCardAndPolyline;
